import { render, staticRenderFns } from "./HirebotPcVersion.vue?vue&type=template&id=010e05f1&scoped=true&"
import script from "./HirebotPcVersion.vue?vue&type=script&lang=js&"
export * from "./HirebotPcVersion.vue?vue&type=script&lang=js&"
import style0 from "./HirebotPcVersion.vue?vue&type=style&index=0&id=010e05f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e05f1",
  null
  
)

export default component.exports